import moment from 'moment/moment'
import { FORMAT_DATE, FORMAT_DATE_INVALID } from './constants'

export default function dateFormat(date, format = FORMAT_DATE) {
  if (!date) throw new Error(FORMAT_DATE_INVALID)
  return moment(date).format(format)
}



// WEBPACK FOOTER //
// ./src/alelo-logic/utils/dateFormat.js